module.exports = __webpack_public_path__ + "img/rio.d68a24c9.svg";